module.exports = __webpack_public_path__ + "img/car-back.aee58e9d.jpg";